import { HTTP_METHODS } from '@studio/constants/axios';
import { HOTSPOTS_API_V1 } from '@studio/constants/env-variables';
import type { Hotspots } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${HOTSPOTS_API_V1}/customers/@customerId/fts`,
    response: {} as Hotspots.Get.FirstTimeSetupStatus,
    method: HTTP_METHODS.GET,
  },
};

export const id = {};
